import { apiClient } from './client';

export interface CreateEventDto {
  eventName: string;
  brgId: number;
  eventDate: string; // YYYY-MM-DD
  eventTime: string; // HH:MM
  eventOrganizer: string;
  eventLocation?: string;
  acceptedAttendees?: string;
  eventDescription?: string;
}

export interface EventDto {
  eventId: number;
  eventName: string;
  brgId: number;
  brgName: string;
  eventDate: string;
  eventTime: string;
  eventOrganizer: string;
  eventLocation?: string;
  acceptedAttendees: number;
  eventDescription?: string;
  createdAt: string;
  updatedAt: string;
  createdByEmail?: string;
}

export const eventsApi = {
  list(brgId?: number): Promise<EventDto[]> {
    const path = brgId ? `/api/events?brgId=${brgId}` : '/api/events';
    return apiClient.get<EventDto[]>(path);
  },

  getById(id: number): Promise<EventDto> {
    return apiClient.get<EventDto>(`/api/events/${id}`);
  },

  create(data: CreateEventDto): Promise<EventDto> {
    return apiClient.post<EventDto>('/api/events', data);
  },

  update(id: number, data: CreateEventDto): Promise<EventDto> {
    return apiClient.patch<EventDto>(`/api/events/${id}`, data);
  },

  delete(id: number): Promise<void> {
    return apiClient.delete<void>(`/api/events/${id}`);
  },
};
